import React, { useEffect, useState } from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { GraduationCap, PlayCircle, FileText } from 'lucide-react'
import { courseApi, lessonApi } from '../api/lessonBuilderApi'
import { countCards } from '../lib/sections'
import type { CourseDoc } from '../types/CourseDoc'
import type { LessonDoc } from '../types/LessonDoc'

// Trang khoá học công khai (giao diện học sinh): bìa + danh sách bài.
const CourseViewerPage: React.FC = () => {
  const { slug } = useParams()
  const navigate = useNavigate()
  const [course, setCourse] = useState<CourseDoc | null | undefined>(undefined)
  const [lessons, setLessons] = useState<LessonDoc[]>([])

  useEffect(() => {
    if (!slug) return
    courseApi.getBySlug(slug).then(async (c) => {
      setCourse(c)
      if (c) {
        const loaded = await Promise.all(c.lessonIds.map((id) => lessonApi.get(id)))
        setLessons(loaded.filter(Boolean) as LessonDoc[])
      }
    }).catch(() => setCourse(null))
  }, [slug])

  if (course === undefined) return <div className="p-10 text-center text-gray-400">Đang tải...</div>
  if (!course) {
    return (
      <div className="p-10 text-center">
        <p className="text-gray-500 mb-4">Không tìm thấy khoá học.</p>
        <Link to="/teacher/khoa-hoc" className="text-blue-600 font-semibold">← Về danh sách khoá học</Link>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <div className="bg-gradient-to-br from-blue-600 to-indigo-700 text-white">
        <div className="max-w-3xl mx-auto px-6 py-12">
          <div className="flex items-center gap-2 text-blue-100 text-sm font-semibold mb-3">
            <GraduationCap size={18} /> Khoá học
          </div>
          <h1 className="text-3xl font-black mb-3">{course.title}</h1>
          {course.description && <p className="text-blue-100 leading-relaxed">{course.description}</p>}
          <p className="text-blue-200 text-sm mt-4">{lessons.length} bài giảng</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto p-6 space-y-3">
        {lessons.length === 0 ? (
          <p className="text-center text-gray-400 py-10">Khoá học chưa có bài giảng.</p>
        ) : (
          lessons.map((l, i) => (
            <button
              key={l.id}
              onClick={() => navigate(`/bai-giang/${l.slug}`)}
              className="w-full flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-100 shadow-sm hover:border-blue-200 hover:shadow-md transition-all text-left"
            >
              <span className="w-9 h-9 rounded-full bg-blue-50 text-blue-600 font-bold flex items-center justify-center shrink-0">
                {i + 1}
              </span>
              <div className="flex-1 min-w-0">
                <p className="font-bold text-gray-900 truncate">{l.meta.tieuDe}</p>
                <p className="text-xs text-gray-400 flex items-center gap-1">
                  <FileText size={12} /> {countCards(l)} mục nội dung
                </p>
              </div>
              <PlayCircle className="text-blue-500 shrink-0" size={22} />
            </button>
          ))
        )}
      </div>
    </div>
  )
}

export default CourseViewerPage
